export const LOCAL_STORAGE: string = "spanishpoint-matchingengine-local";
export const LOCAL_STORAGE_VERSION: string = "spanishpoint-matchingengine-local-version";
export const SESSION_STORAGE: string = "spanishpoint-matchingengine-session";